module.exports = __webpack_public_path__ + "static/media/grasstile.ac778cb5.png";